import React from 'react';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import LANGUAGE_CONTROLLER from '../../../controllers/languages';
import { SSelect } from '@avalara/skylab-sdk/react';

const log = new Logger('SINGLE_CUSTOMER_SELECTOR', LOG_LEVELS.ERROR);

export class SingleCustomerSelector extends React.Component {

    onSelectionChange(event) {
        const fieldName=this.props.fieldName;
        log.debug('onSelectionChange(): %s, ', fieldName, event);
        const newValue = event?.detail?.item?.value ?? '';
        log.debug('onSelectionChange(): %s, oldValue: %s, newValue: %s  ', fieldName, this.props.selectedCustomerId, newValue);
        let selection = {};
        selection[fieldName] = newValue !== '' ? newValue : undefined;
        this.props.selectionHandler(selection);
    }

    render() {
        log.debug('render(): ', this.props);
        const optionsList = [
            { label: LANGUAGE_CONTROLLER.format(this.props.languageString, "customer_SelectAccountId"), value: '' },
            ...((this.props.customerList || []).map((customer, key) => ({
                label: customer.id,
                value: customer.id,
                selected: this.props.selectedCustomerId === customer.id
            })))
        ];
        return (
            <SSelect
                inputId="customer-single-select"
                name="customers"
                onS-select={this.onSelectionChange.bind(this)}
                optionsList={optionsList}
                multiple={false}
                showSelectionCount={false}
            />
        )
    }
}



// Wrap the component to inject state into it
export default (SingleCustomerSelector);